const textAreaStyles = (tokens) => ({
    variants: {
        primary: {
            borderRadius: tokens.BorderRadius02,
            borderWidth: tokens.BorderWidth01,
            paddingTop: tokens.Spacing04,
            paddingBottom: tokens.Spacing04,
            paddingLeft: tokens.Spacing05,
            paddingRight: tokens.Spacing05,
            borderColor: tokens.BorderLight500,
            backgroundColor: tokens.Grey200,
            _placeholder: {
                color: tokens.TextLight500,
            },
            _focusVisible: {
                outline: `2px solid ${tokens.BorderFocus}`,
            },
            _focus: {
                color: tokens.TextMedium600,
                bgColor: tokens.Layer01,
                background: tokens.Layer01,
            },
        },
    },
});
export default textAreaStyles;
